import { Link } from 'react-router-dom';
import { IconDownload, IconMail } from '../components/Icons';
import useScrollReveal from '../hooks/useScrollReveal';
import './About.css';

const currentEngagements = [
  'Inter-Religious Studies (IRS), Graduate School of Universitas Gadjah Mada (UGM)',
  'Vice President of Geneva-based Globethics, Switzerland',
  'Founder and President of the Board, Yayasan Dharma Etika Mandiri (YDEMA)',
  'Founder and President of the Board, Yayasan Kemitraan Akademik & Kemanusiaan (YKAP)',
  'CEO, Designer and Curator, Nglanggeran Eco-Village in Patuk, Gunung Kidul',
  'Senior Consultant for UNDP, Greenpeace MENA, PaRD, World Vision Indonesia, Joint Learning Initiatives, Bappenas, MoRA, MoFA, etc.'
];



export default function About() {
  useScrollReveal();

  return (
    <main>
      <section className="page-hero" aria-labelledby="about-heading">
        <div className="container">
          <span className="section-label">About</span>
          <h1 id="about-heading">Dr. Dicky Sofjan</h1>
          <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.75)' }}>
            Vice President of Globethics and academic strategist specializing in the intersection of faith, governance, and environmental ethics — 20+ Years Bridging Academia, Interfaith Dialogue, and Global Sustainability
          </p>
        </div>
      </section>

      {/* Biography */}
      <section className="section" aria-labelledby="bio-heading">
        <div className="container">
          <div className="about__grid">
            {/* Sidebar */}
            <aside className="about__sidebar reveal reveal-photo">
              <div className="about__photo-wrap">
                <img
                  src="/dr sofjan/3.jpeg"
                  alt="Dr. Dicky Sofjan"
                  className="about__photo"
                  loading="lazy"
                />
              </div>
              <div className="about__sidebar-info">
                  <div className="about__info-item"><span>Position</span><strong>Associate Professor</strong></div>
                 <div className="about__info-item"><span>Institution</span><strong>Universitas Gadjah Mada</strong></div>
                 <div className="about__info-item"><span>Program</span><strong>Inter-Religious Studies</strong></div>
                 <div className="about__info-item"><span>Other Role</span><strong>Global Vice President, Globethics</strong></div>
                <div className="about__info-item"><span>Location</span><strong>Yogyakarta, Indonesia</strong></div>
                <div className="about__info-item"><span>Experience</span><strong>20+ Years International</strong></div>
              </div>
              <div className="about__sidebar-cta">
                <a href="/Dicky Sofjan 2026 CV.pdf" download className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', gap: '0.5rem' }}>
                  <IconDownload size={15} color="currentColor" /> Download CV (PDF)
                </a>
                <Link to="/contact" className="btn btn-outline" style={{ width: '100%', justifyContent: 'center', gap: '0.5rem' }}>
                  <IconMail size={15} color="currentColor" /> Contact Dr. Sofjan
                </Link>
              </div>
            </aside>

            {/* Biography text */}
            <article className="reveal reveal-up">
              <span className="section-label">Biography</span>
              <h2 id="bio-heading" className="section-title">A Dedicated Academic Strategist</h2>
              <p>Dr. Sofjan’s work sits at the intersection of academic research and social advocacy. His scholarship explores the complex ties between religion, politics, and sustainability—with a particular focus on Islamic ethics. This expertise has made him a trusted advisor to government bodies both in Indonesia and abroad. As a founder driven by ethical practice, he bridges the gap between theory and action, leveraging a global network of development agencies and philanthropic organizations to drive meaningful change. Dr. Sofjan has earned numerous research grants and built collaborative partnerships with the Ford, Templeton, Henry Luce, Nippon Foundations, Partnership for Religion and Sustainable Development (PaRD), Greenpeace, Carnegie Council, European Union, US State Department, The Nature Conservancy, UNDP, UNESCO, KAICIID, MCC, Focolare and other international organizations and development agencies.</p>
              <p>He was appointed as a Visiting Professor/Fellow in Japan, Malaysia, Bulgaria, Italy and Iran, and has visited and taught in a number of universities in the US and also the US Foreign Service Institute (FSI) in Virginia. Dr. Sofjan has spoken in over 100 international academic conferences, academic workshops and strategic international events around the world, including UNFCCC/COP, World Urban Forum-UN Habitat, Future Earth, ICCS, AIGCHR-ASEAN, etc. Since 2023, Dr. Sofjan has been part of Depolarization Community of Practitioners along with other researchers and experts with IFIT (ifit-transitions.org).</p>
              <p>Dr. Sofjan’s academic books, edited volumes and journal articles have been published in Springer Nature, Review of Faith and International Affairs, Asia-Pacific Network (APN) Science Bulletin, Journals of Religions, Hemispheres, South Asian and Middle Eastern Studies, Al-Jami’ah, Globethics, Areca Books, Gramedia Kompas, Yayasan Obor, Mizan, etc. His interviews and quotes have been published and aired by international news outlets such as Forbes.com, Voice of America, The Economist, The Diplomat, Digital News Asia, Jakarta Post, Pakistan’s National Herald, Corriere della Sera, La Repubblica, and others. Dr. Sofjan social entrepreneurship extends to designing and curating an inspirational and sustainable “Nglanggeran Eco-Village”, located in Gunung Kidul, where he gathers social entrepreneurs and green investors to help develop Nglanggeran, an ancient village in Yogyakarta that received the Best International Village Tourism by the United Nations World Tourism Organization (UNWTO).</p>
            </article>
          </div>
        </div>
      </section>

      {/* Current Employment & Affiliations */}
      <section className="section section-alt" aria-labelledby="engagements-heading">
        <div className="container">
          <div className="text-center" style={{ marginBottom: '3rem' }}>
            <span className="section-label">Engagements</span>
            <h2 id="engagements-heading" className="section-title">Current Employment, Affiliations & Engagements</h2>
          </div>
          <div className="grid-2" style={{ maxWidth: '800px', margin: '0 auto', gap: '2rem' }}>
            {currentEngagements.map((item, i) => (
              <div key={i} className={`reveal reveal-up delay-${(i % 3) + 1}`} style={{ background: 'var(--bg-card)', padding: '1.5rem', borderRadius: '12px', boxShadow: '0 4px 15px var(--shadow)', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <span style={{ fontSize: '1.5rem', color: 'var(--gold)' }}>•</span>
                <span style={{ fontWeight: 500, lineHeight: 1.5, color: 'var(--text-dark)' }}>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* Passions & Personal Interests */}
      <section className="section" aria-labelledby="passions-heading">
        <div className="container">
          <div className="text-center" style={{ marginBottom: '3rem' }}>
            <span className="section-label">Life & Passions</span>
            <h2 id="passions-heading" className="section-title">Beyond Academia</h2>
          </div>
          <div className="about__passions-grid">
            <div className="about__passion-card" style={{ gridColumn: '1 / -1' }}>
              <p style={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                Dr. Sofjan is a conservationist and avid traveler, and has visited over 40 countries. He listens to music, plays the guitar (classical, acoustic and electric), scrabble, chess, badminton, tennis, table tennis and billiards. He swims almost everyday, and was previously a Karateka, winning a medal in Kumite (combat fighting). Dr. Sofjan is also a PADI Certified Advanced Diver, who has conducted logged dives in Komodo National Park (East Nusa Tenggara), Raja Ampat (West Papua), Derawan (East Kalimantan) and Gili Trawangan (Lombok).
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
